export const ADMIN_ROUTES = {
    ROOT: '/admin-panel',
    LOGIN: {
        PATH: 'login',
        FULL: '/login',
    },
    MAIN: {
        PATH: 'main',
        FULL: '/admin-panel/main',
    },
    TEAM: {
        PATH: 'team',
        FULL: '/admin-panel/team',
    },
    PROGRAMS: {
        PATH: 'programs',
        FULL: '/admin-panel/programs',
    },
    DONATE: {
        PATH: 'donate',
        FULL: '/admin-panel/donate',
    },
    FAQ: {
        PATH: 'faq',
        FULL: '/admin-panel/faq',
    },
    WHO_WE_ARE: {
        PATH: 'who-we-are',
        FULL: '/admin-panel/who-we-are',
    },
    EVENTS: {
        PATH: 'events',
        FULL: '/admin-panel/events',
    },
    PARTNERS: {
        PATH: 'partners',
        FULL: '/admin-panel/partners',
    },
    PROFILE_COMPANY: {
        PATH: 'company-profile',
        FULL: '/admin-panel/company-profile',
    },
    REPORTS: {
        PATH: 'reports',
        FULL: '/admin-panel/reports',
    },
    HISTORY: {
        PATH: 'history',
        FULL: '/admin-panel/history',
    },
    HIPPOTHERAPY: {
        PATH: 'hippotherapy',
        FULL: '/admin-panel/hippotherapy',
    },
    FEEDBACK: {
        PATH: 'feedback',
        FULL: '/admin-panel/feedback',
    },
};
